module.exports = __webpack_public_path__ + "img/4.6c423f01.png";